/**
 * 사람이 적은 주소를 웹 링크로 걸어도 되는지.
 * @description 스레드 글의 링크는 누구나 적을 수 있다. `javascript:` 같은 주소를 `href` 에 그대로
 *   넣으면 누르는 순간 스크립트가 돈다 — http · https 만 통과시킨다.
 * @example safeHttpUrl("https://x.com/a") // "https://x.com/a"
 * @example safeHttpUrl("javascript:alert(1)") // null
 */
const ALLOWED_PROTOCOLS = new Set(["http:", "https:"]);

export function safeHttpUrl(raw: string | null | undefined): string | null {
  const value = raw?.trim();
  if (!value) return null;
  try {
    const url = new URL(value);
    return ALLOWED_PROTOCOLS.has(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
}
